export default "__VITE_ASSET__ce772d92__"